import { Box, styled } from '@mui/material';

import { JobSliderContainerStyle } from './JobBlock.types';

export const JobBlockContainer = styled(Box)(() => ({
  width: '100%',
  padding: '12px',

  display: 'flex',
  flexDirection: 'column',
  rowGap: '48px',

  boxSizing: 'border-box',
  overflow: 'hidden',
}));

export const JobSliderContainer = styled('div')(
  ({ isBlockActive }: JobSliderContainerStyle) => ({
    width: '100%',
    maxWidth: '736px',

    display: 'grid',
    gridTemplateColumns: `${isBlockActive ? '112px auto' : '100% auto'}`,
    gap: '24px',

    transition: 'grid-template-columns .3s linear',

    '@media screen and (min-width: 1920px)': {
      maxWidth: '822px',
      gridTemplateColumns: `${isBlockActive ? '198px auto' : '100% auto'}`,
    },

    '@media screen and (min-width: 2120px)': {
      maxWidth: '1022px',
    },

    '@media screen and (max-width: 1280px)': {
      maxWidth: 'unset',
      gridTemplateColumns: `${
        isBlockActive ? '112px calc(100% - 136px)' : '100% calc(100% - 136px)'
      }`,
    },

    '@media screen and (max-width: 640px)': {
      maxWidth: 'unset',
      gridTemplateColumns: 'none',
      gridTemplateRows: 'auto 1fr',
    },
  }),
);
